export default function({link, toggle}){
    

    return(
        <div id="compartilhar" className=" z-[10000000] w-[300px]  bg-white font-roboto text-base font-normal p-4 text-[#333333] rounded-lg flex flex-col fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 shadow-lg">
            <div className="flex flex-row">
                <h1 className="text-xl">Compartilhe</h1>
                <img onClick={()=>{toggle(false)}} className=" ml-auto h-4" src="../assets/close.png"/>
            </div>

            <div className="flex flex-row mt-6 mb-4">
                {/* <div>
                    <img src="./src/assets/navigate_icon_2.png"/>
                </div> */}
                <div className=" overflow-x-auto w-full h-[60px] flex flex-row items-center p-3 justify-evenly">
                    <a target='_blank' href={'https://www.facebook.com/sharer/sharer.php?u=' + link}>
                        <img className=" rounded-full h-9 hover:scale-105" src="../assets/facebook_lg.png"/>
                    </a>
                    <a target='_blank' href={'https://api.whatsapp.com/send?text=' + link}>
                        <img className="rounded-full h-9 hover:scale-105" src="../assets/whatsApp_lg.png"/>
                    </a>
                    <a target='_blank' href={'https://www.linkedin.com/shareArticle?mini=true&url=' + link}>
                        <img className="rounded-full h-9 hover:scale-105" src="../assets/linkedin_lg.png"/>
                    </a>
                    <a target='_blank' href={'https://x.com/intent/tweet?url=' + link}>
                        <img className="rounded-full h-9 hover:scale-105" src="../assets/x_lg.png"/>
                    </a>
                </div>
                {/* <div>
                    <img src="./src/assets/navigate_icon_2.png" className=" rotate-180"/>
                </div> */}
            </div>
           


        </div>
    )
}